export const seriesId = [
  "c0_gini",
  "c0_remuneracion_bruta_de_la_propiedad_pib",
  "c1_gini_a",
  "c1_gini_b",
  "c1_l",
]

export const seriesEsp = [
  "Gini",
  "Remuneración de la propiedad (% PIB)",
  "Gini A",
  "Gini B",
  "L",
]

export const seriesEng = [
  "Gini",
  "Property share (% GDP)",
  "Gini A",
  "Gini B",
  "L",
]

export const groupsEsp = [
  "El índice de Gini y la remuneración de la propiedad (% PIB)",
  "El índice de Gini y la remuneración de la propiedad (% PIB)",
  "El índice de Gini y su composición",
  "El índice de Gini y su composición",
  "El índice de Gini y su composición",
]

export const groupsEng = [
  "The Gini Index and the Property Share (% GDP)*",
  "The Gini Index and the Property Share (% GDP)*",
  "The Gini index and its composition",
  "The Gini index and its composition",
  "The Gini index and its composition",
]
